var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import { BRow, BCol } from 'bootstrap-vue';
import axios from 'axios';
import FrameProductExtra from 'components/picture-frames/Tabs/FrameExtras/FrameProductExtra.vue';
let FrameProductExtras = class FrameProductExtras extends Vue {
    products = [];
    async mounted() {
        // Get the extras to add to cart
        let { data } = await axios.get('/api/frameDesigner/productExtras');
        this.products = data;
    }
};
FrameProductExtras = __decorate([
    Component({
        components: {
            BRow, BCol,
            FrameProductExtra
        }
    })
], FrameProductExtras);
export default FrameProductExtras;
